import React from 'react'
import { render } from 'react-dom'
import { createInertiaApp } from '@inertiajs/inertia-react'
import { InertiaProgress } from '@inertiajs/progress'
import { Inertia } from '@inertiajs/inertia'

InertiaProgress.init({
    delay: 0,
    color: '#01BCD4',
    showSpinner: true,
});

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, App, props }) {
        render(<App {...props} />, el)
    },
})

Inertia.on('navigate', (event) => {   
    gtag('event', 'page_view', {
        'page_location': event.detail.page.url
    });
})